import React, { memo } from 'react';
import { Text, StyleSheet } from 'react-native';

import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';

const FormError = (props) => (
	<Text style={styles.errorText}>
		{props.message}
	</Text>
);

const styles = StyleSheet.create({
	errorText: {
		fontFamily: FONTS.default,
		fontSize: FONT_SIZES.sm,
		color: COLORS.textError
	}
});

export default memo(FormError);